import React, { useEffect, useRef } from 'react'
import { useTranslation } from '../../../i18n/useTranslation'
import { useTheme } from '@mui/material'
import { isMobileAll } from '../../../utils'

type NextButtonProps = {
    loading: boolean
    onClick: () => void
    requestEnterFocus?: boolean
}

// FIXME use material ui button
const buttonClassDesktop = 'mt-2 mx-2 px-4 py-2 rounded-lg border border-solid text-xl';
const buttonClassMobile = 'mt-2 mx-2 px-1 py-1 rounded-lg border border-solid text-lg';

export const NextButton: React.FC<NextButtonProps> = ({
    loading,
    onClick,
    requestEnterFocus = false,
}) => {
    const t = useTranslation()
    const muiTheme = useTheme()
    const buttonRef = useRef<HTMLButtonElement>(null)

    useEffect(() => {
        if (requestEnterFocus && buttonRef.current) {
            buttonRef.current.focus()
        }
    }, [requestEnterFocus])

    const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
        console.debug('>>> handleKeyDown', event.key)
        if (event.key === 'Enter' && !loading) {
            onClick()
            event.preventDefault()
            event.stopPropagation()
        }
    }

    return (
        <button
            ref={buttonRef}
            className={isMobileAll() ? buttonClassMobile : buttonClassDesktop}
            style={{
                backgroundColor: muiTheme.palette.primary.main,
                color: muiTheme.palette.primary.contrastText,
            }}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            disabled={loading}
        >
            {loading ? t('loading') : t('btn_next_step')}
        </button>
    )
}
